async function getAllPacingsSchedules(token) {
  const requestOptions = {
    method: 'GET',
    headers: { 'x-auth-token': token },
  };

  let data = await fetch(
    'https://book-backend-ki7x.onrender.com/api/pacingsschedules',
    requestOptions,
  );

  return JSON.parse(await data.text());
}

async function postPacingsSchedule(token, pacingsSchedule) {
  try {
    const requestOptions = {
      method: 'POST',
      headers: { 'x-auth-token': token, 'Content-Type': 'application/json' },
      body: JSON.stringify(pacingsSchedule),
    };

    let data = await fetch(
      'https://book-backend-ki7x.onrender.com/api/pacingsschedules',
      requestOptions,
    );

    if (!data.ok) {
      data.text().then((res) => {
        console.log(data.status + ' ' + data.statusText + ' ' + res);
      });
      return false;
    }

    let result = JSON.parse(await data.text());

    // convert all the dates into JS Date() objects...

    return result;
  } catch (err) {
    console.log(err.message);
    return false;
  }
}

async function putPacingsSchedule(token, pacingsSchedule) {
  try {
    const requestOptions = {
      method: 'PUT',
      headers: { 'x-auth-token': token, 'Content-Type': 'application/json' },
      body: JSON.stringify(pacingsSchedule),
    };

    let data = await fetch(
      'https://book-backend-ki7x.onrender.com/api/pacingsschedules/' +
        pacingsSchedule._id,
      requestOptions,
    );

    if (!data.ok) {
      data.text().then((res) => {
        console.log(data.status + ' ' + data.statusText + ' ' + res);
      });

      console.log('fail');
      return false;
    }

    let result = JSON.parse(await data.text());

    console.log('success!');
    return result;
  } catch (err) {
    console.log(err.message);

    console.log('fail');
    return false;
  }
}

const _getAllPacingsSchedules = getAllPacingsSchedules;
export { _getAllPacingsSchedules as getAllPacingsSchedules };

const _postPacingsSchedule = postPacingsSchedule;
export { _postPacingsSchedule as postPacingsSchedule };
const _putPacingsSchedule = putPacingsSchedule;
export { _putPacingsSchedule as putPacingsSchedule };
